import React from 'react';

const faqs = [
  {
    question: "What makes a good meta title?",
    answer: "A good meta title should be descriptive, include relevant keywords, stay under 60 characters, and accurately represent the page content while being engaging for users."
  },
  {
    question: "How does the AI generate meta titles?",
    answer: "Our AI analyzes your content, keywords, and industry best practices to generate optimized meta titles that balance SEO requirements with user engagement."
  },
  {
    question: "Should I use the same meta title format for all pages?",
    answer: "While maintaining consistency is important, each page should have a unique meta title that reflects its specific content and purpose."
  },
  {
    question: "How important are meta titles for SEO?",
    answer: "Meta titles are one of the most important on-page SEO elements. They help search engines understand your content and appear as the clickable headline in search results."
  },
  {
    question: "Can I edit the generated titles?",
    answer: "Yes! You can modify any generated title to better match your needs while maintaining the suggested structure and optimization."
  },
  {
    question: "How often should I update my meta titles?",
    answer: "Consider updating meta titles when your content changes significantly, when targeting new keywords, or if you notice declining search performance."
  }
];

export default function MetaFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Meta Title Generator FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-emerald-50 p-6 rounded-lg transform transition-all duration-300 hover:scale-[1.02]">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}